module.exports = __webpack_public_path__ + "img/g6_micaiwuxue.52536609.jpg";